import { Box, Checkbox, FormControlLabel, MenuItem, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material";
import { fedVerseTypes } from "../asset/variables";
import moment from "moment";

export default function Step1(props) {
    return(
        <Stack direction='column' spacing={3}>
            <Box>
                <Typography variant="subtitle1">Versement FEAM</Typography>
                <RadioGroup row sx={{minWidth:'500px'}} defaultValue="siège" value={props.fedVerseType} onChange={(event)=> props.setFedVerseType(event.target.value)}>
                    {fedVerseTypes.map(versetype=>((['virement','cheque'].includes(versetype.value)? props.eglise.have_banque: !props.eglise.have_banque)||versetype.value==='siege')&&<FormControlLabel key={versetype.value} value={versetype.value} control={<Radio/>} label={versetype.label} />)}
                </RadioGroup>
            </Box>
            <Box>
                <Typography variant="subtitle1">Prendre une petite caisse:</Typography>
                <Stack direction='row' spacing={3} alignItems='center'>
                    <FormControlLabel control={<Checkbox checked={props.take_petite_caisse} onChange={()=>props.setTakePetiteCaisse(old=>!old)}/>} label="Oui" />
                    <FormControlLabel control={<Checkbox checked={!props.take_petite_caisse} onChange={()=>props.setTakePetiteCaisse(old=>!old)}/>} label="Non" />
                </Stack>
            </Box>
            {!props.isEdit&&<Box>
                <Typography variant="subtitle1">Période</Typography>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <Typography>Verser les dons du</Typography>
                    <TextField select size="small" sx={{width:'20%', minWidth:'120px'}} value={props.dateDons} onChange={e=>props.setDate(e.target.value)}>
                        {props.dispoDates.sort((a,b)=>new Date(a).getTime()-new Date(b).getTime()).map(date=><MenuItem key={date} value={date}>{moment.utc(date).format('DD/MM/yyyy')}</MenuItem>)}
                    </TextField>
                </Stack>
            </Box>}
        </Stack>
    )
}